module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share"
  }, [_c('header-bar'), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "rep-diagram"
  }, [_c('div', {
    staticClass: "image-circle"
  }, [(this.$root.profile.profileimg === 'default') ? _c('img', {
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _c('img', {
    attrs: {
      "src": this.$root.profile.profileimg
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("=")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p', [_vm._v("Invite people that love to make things happen with your unique URL and earn +5 reputation when they sign up.")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": 'https://share.pei.exchange/' + this.$root.profile.slug
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-square facebook",
    attrs: {
      "href": 'https://www.facebook.com/sharer/sharer.php?u=https%3A//share.pei.exchange/' + this.$root.profile.slug,
      "target": "_blank"
    }
  }, [_vm._v("Invite Over Facebook")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-square twitter",
    attrs: {
      "href": 'https://twitter.com/home?status=I\'ve%20just%20created%20an%20account%20on%20PEI%20exCHANGE,%20why%20not%20join%20me%20in%20supporting%20African%20development?%20https%3A//share.pei.exchange/' + this.$root.profile.slug,
      "target": "_blank"
    }
  }, [_vm._v("Invite Over Twitter")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-square email",
    attrs: {
      "href": 'mailto:?&subject=Join me on PEI exCHANGE&body=Hello,%0A%0AI\'ve%20just%20created%20an%20account%20on%20PEI%20exCHANGE.%0A%0Ahttps%3A//share.pei.exchange/' + this.$root.profile.slug + '%0A',
      "target": "_blank"
    }
  }, [_vm._v("Invite Over Email")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-circle"
  }, [_c('span', [_vm._v("+5")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14164327"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Share.vue
// module id = 677
// module chunks = 1